export enum SectionType {
  CompanyData = 'companyData',
  CompanyInfo = 'companyInfo',
  DebitCard = 'debitCard',
  AccountSelector = 'accountSelector',
  TrusteeData = 'trusteeData',
  StatementsAndContracts = 'statements',
  IdAndV = 'verification',
}
